module.exports = __webpack_public_path__ + "static/media/iconParametreActive.85744987.svg";